import React, {Component, Fragment} from 'react';
import Typography from "@mui/material/Typography";
import {Divider, IconButton, InputAdornment, InputBase, Paper, TextField} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
class SearchEngine extends Component {
    render() {
        return (
            <Paper component="form" sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}>
                <TextField placeholder="Where would you like to go?"  InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                }} variant="outlined"  />
                <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
                    <SearchIcon />
                </IconButton>
            </Paper>
        );
    }
}

export default SearchEngine;